<template>
  <div class="contents contents--list">
    <div class="contents--list-subject">
      <span>Transactions</span>
      <RecordSelectBox :record="record" @changeRecord="changeRecord" />
    </div>

    <div class="search-box">
      <div class="search-inner-box">
        <div class="option option--datetime">
          <label>From (UTC +0)</label>
          <Datetime
            v-model="searchFilter.from_time"
            input-id="search_from_time"
            type="datetime"
            zone="UTC"
            minute-step="5"
            input-style="padding:0; width:100%; border:none; color:#333; font-family: Spoqa Han Sans;"
            @close="searchByDate"
          />
        </div>
        <div class="option option--datetime">
          <label>To (UTC +0)</label>
          <Datetime
            v-model="searchFilter.to_time"
            input-id="search_to_time"
            type="datetime"
            zone="UTC"
            minute-step="5"
            input-style="padding:0; width:100%; border:none; color:#333; font-family: Spoqa Han Sans;"
            @close="searchByDate"
          />

        </div>
        <div class="option">
          <label>FUNCTION</label>
          <!-- <input v-model="searchFilter.function_name" @keydown.enter="search" /> -->
          <select v-model="searchFilter.function_name" @change="search">
              <option value="All function">All function</option>
              <option v-for="fn in functionOptions" :key="fn" :value="fn">
                {{ fn }}
              </option>
          </select>
          <!-- <button title="search transactions" @click="search">
            <img src="../../assets/img/magnifier.svg" alt="Search" />
          </button> -->
          <button
            v-if="this.from_time || this.to_time"
            title="reset time filter"
            @click="reset_timefilter"
          >
            <img src="../../assets/img/menu-cancel.svg" alt="Reset" />
          </button>
        </div>
      </div>
    </div>

    <div v-if="noResults && !loading" class="no-result-msg">
      No Results.
    </div>
    <Table v-if="!noResults" width="900px" data-type="txs" :data="txs" />

    <Pagination v-if="!noResults"
      :isDetail="false"
      :minID="min_id"
      :maxID="max_id"
      :lastID="last_id"
      :currentID="current_id"
      :firstPage="(this.current_id == this.max_id)"
      :lastPage="(this.last_id == this.min_id)"
      :loading="loading"
      @flip="pageCall"
    />
  </div>
</template>

<script>
import RecordSelectBox from "./shared/RecordSelectBox.vue";
import Table from "./shared/Table.vue";
import Pagination from "./shared/Pagination.vue";
import { Datetime } from "vue-datetime";
import callAPI from "../../api/http";
import { convertAttrFormat } from "../../js/format";
import { RecordOptions } from "../../js/fields";
import { styleNav } from "../../js/style";

export default {
  name: "TransactionsList",

  props: {
    from_time: {
      type: String,
      default: undefined,
    },
    to_time: {
      type: String,
      default: undefined,
    },
    bookmark: {
      type: Number,
      default: undefined,
    },
    pagesize: {
      type: Number,
      default: RecordOptions[1],
    },
    direction: {
      type: String,
      default: "first",
    },
    function_name: {
      type: String,
      default: "",
    }
  },

  components: {
    RecordSelectBox,
    Table,
    Pagination,
    Datetime,
  },

  computed: {
    noResults() {
      return (this.totalTxs == 0)
    },
    isBurn() {
    return this.searchFilter.function_name === "token/burn";
    },

    query() {
    return {
      bookmark: this.bookmark,
      pagesize: this.pagesize,
      direction: this.direction,
      from_time: this.isBurn
        ? this.BURN_FROM_UTC
        : (this.searchFilter.from_time ? this.searchFilter.from_time : undefined),
      to_time: this.isBurn
        ? this.utcNow() // 항상 현재시각
        : (this.searchFilter.to_time ? this.searchFilter.to_time : undefined),
      function_name: this.searchFilter.function_name === "All function"
        ? undefined
        : this.searchFilter.function_name,
    };
    },

    searchFilter() {
      return {
        from_time: this.from_time,
        to_time: this.to_time,
        function_name: this.function_name || "All function",
      };
    },
  },

  async beforeRouteUpdate({ query }, from, next) {
    this.bookmark = query.bookmark || 0;
    this.pagesize = query.pagesize || RecordOptions[1];
    this.direction = query.direction || "first";
    this.from_time = query.from_time;
    this.to_time = query.to_time;
    this.function_name = query.function_name;
    this.record = this.pagesize;
    await this.getTxs();

    next();
  },

  async created() {
    this.record = this.pagesize;
    await this.getTxs();
  },

  mounted() {
    if (this.searchFilter.function_name == "token/burn"){
      styleNav(7);
    }else{
      styleNav(3);
    }
  },

  updated() {
    if (this.searchFilter.function_name == "token/burn"){
      styleNav(7);
    }else{
      styleNav(3);
    }
  },

  data() {
    return {
      txs: null,
      totalTxs: 0,
      loading: false,
      min_id: 0,
      max_id: 0,
      last_id: 0,
      current_id: 0,

      BURN_FROM_UTC: "2019-04-08T06:19:19Z",

      functionOptions: [
        "account/create",
        "account/holder/add",
        "account/suspend",
        "account/unsuspend",
        "approve",
        "balance/pending/withdraw",
        "disapprove",
        "fee/prune",
        "lock",
        "pay",
        "pay/prune",
        "pay/refund",
        "register",
        "token",
        "token/burn",
        "token/update",
        "transfer",
        "unlock",
        "unwrap",
        "wrap",
        "wrap/complete",
      ],
    };
  },

  methods: {
    async getTxs() {
      this.loading = true;
      const { data, errCode } = await callAPI("getTxs", this.query);
      this.setTxs(data, errCode);
    },

    utcNow() {
      return new Date().toISOString();
    },

    pageCall(direction) {
      switch (direction) {
        case "next":
          this.bookmark = this.txs[this.txs.length - 1].id;
          this.direction = direction;
          break;
        case "prev":
          this.bookmark = this.txs[0].id;
          this.direction = direction;
          break;
        default:
          this.bookmark = undefined;
          this.direction = direction;
      }
      this.route();
    },

    changeRecord(pagesize) {
      if (this.pagesize === pagesize) {
        return;
      }

      this.pagesize = pagesize;
      this.route();
    },

    route() {
      this.$router
        .push({ path: "/txs", query: this.query })
        .catch((err) => console.log(err));
    },

    // From, To 피커에서 날짜를 선택해 피커가 닫힐 때 호출된다.
    // From, To 가 모두 채워졌을 때만 검색을 실행하며, 선택된 FUNCTION 이 있으면 함께 적용한다.
    searchByDate() {
      const from = this.searchFilter.from_time;
      const to = this.searchFilter.to_time;
      if (!from || !to) {
        return;
      }
      if (new Date(from) > new Date(to)) {
        alert("From date should be less than To date.");
        return;
      }
      const functionName = this.searchFilter.function_name === "All function"
        ? undefined
        : this.searchFilter.function_name;
      this.loading = true;
      this.$router
        .push({
          path: "/txs",
          query: {
            pagesize: this.pagesize,
            direction: "first",
            from_time: from,
            to_time: to,
            function_name: functionName,
          },
        })
        .catch((err) => console.log(err));
    },

    search() {
            // function_name이 "All function"이 아니면 from_time, to_time 필수
      if (this.searchFilter.function_name !== "All function") {
        if (
          !this.searchFilter.from_time ||
          !this.searchFilter.to_time ||
          this.searchFilter.from_time === "" ||
          this.searchFilter.to_time === ""
        ) {
          alert("When a FUNCTION is selected, both From and To dates are required.");
          return;
        }
      }
      if (new Date(this.query.from_time) > new Date(this.query.to_time)) {
        alert("From date should be less than To date.");
        return;
      }

      if (this.searchFilter.function_name === "All function") {
        this.$router.push({ path: "/txs" });
        return;
      }

      if (!this.searchFilter.from_time && !this.searchFilter.to_time && !this.searchFilter.function_name) {
        return;
      }

      // 조건이 같아도 강제로 검색
      this.query.bookmark = undefined;
      this.query.direction = "first";
      this.query.from_time = this.searchFilter.from_time
        ? this.searchFilter.from_time
        : undefined;
      this.query.to_time = this.searchFilter.to_time
        ? this.searchFilter.to_time
        : undefined;
      this.query.function_name = this.searchFilter.function_name === "All function"
        ? undefined
        : this.searchFilter.function_name;
      this.loading = true;
      this.route();
    },

    reset_timefilter() {
      // function_name을 'All function'으로 리셋
      this.$router.push({
        path: "/txs",
        query: {
          bookmark: undefined,
          pagesize: this.pagesize,
          direction: "first",
          from_time: undefined,
          to_time: undefined,
          function_name: undefined, // 'All function'은 undefined로 넘김
          _t: Date.now() // 항상 쿼리가 달라지게 함
        }
      }).catch((err) => console.log(err));
    },

    setTxs(data, errCode) {
      if (errCode) {
        console.log(errCode);
        this.txs = [];
        this.totalTxs = 0;
        this.loading = false;
        return;
      }
      const { txs, min_id, current_id, max_id } = data;
      if (txs && txs.length > 0) {
        this.txs = convertAttrFormat(this.$options.name, txs);
        this.min_id = min_id;
        this.current_id = current_id;
        this.max_id = max_id;
        this.totalTxs = txs.length;
        this.last_id = txs[txs.length-1].id;
      } else {
        this.txs = [];
        this.totalTxs = 0;
        this.last_id = 0;
        this.min_id = 0;
        this.current_id = 0;
        this.max_id = 0;
      }
      this.loading = false;
    },
  },
  watch: {
    // FUNCTION 변경 시 token/burn이면 날짜 자동 채우기
    function_name: {
      immediate: true,
      handler(val) {
        if (val === "token/burn") {
          this.from_time = this.BURN_FROM_UTC;
          this.to_time = this.utcNow();
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.search-box {
  overflow-x: auto;
}

.search-inner-box {
  min-width: 550px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 10px 0;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  margin-top: 15px;

  .option {
    display: flex;
    align-items: center;
  }

  .option label {
    flex: none;
    min-width: 115px;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 700;
  }

  .option--datetime {
    display: flex;
    span {
      margin: 0 8px;
      font-weight: 500;
    }
  }

  input {
    width: 200px;
    height: 25px;
    box-sizing: border-box;
    padding-left: 8px;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    font-size: 13px;
    color: #333;
    outline: none;
    font-family: Spoqa Han Sans, "Sans-serif";
  }

  .option select {
    width: 200px;
    height: 25px;
    box-sizing: border-box;
    padding-left: 8px;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    font-size: 13px;
    color: #333;
    background-color: #fff;
    font-family: Spoqa Han Sans, "Sans-serif";
    appearance: none; // 기본 브라우저 스타일 제거 (중요!)
    outline: none;

    // 선택 박스에 오른쪽 화살표 넣기 (선택 사항)
    background-image: url('data:image/svg+xml;charset=US-ASCII,<svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><path fill="%23999" d="M2 4l4 4 4-4z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 10px;
    padding-right: 30px;
  }

  .vdatetime {
    width: 200px;
    height: 25px;
    padding: 0 8px;
    display: flex;
    box-sizing: border-box;
    border: 1px solid #ebebeb;
    border-radius: 10px;
  }

  // button {
  //   margin-left: 10px;
  //   height: 25px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   border: none;
  //   border-radius: 10px;
  //   background-color: #0393f4;
  //   cursor: pointer;
  // }

  // button > img {
  //   width: 80%;
  //   height: auto;
  // }
}

.no-result-msg {
  padding-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/TransactionsList.vue